// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Lottie from 'react-lottie';
import loaderData from '../data/loader';
import useDarkMode from '../utilities/darkMode';

export default class Loader extends React.Component {

    state = { tmp: 0 }

    componentDidMount = () => this.setLoaderData(this.props.user);
    componentDidUpdate = (prev) => {
        if (this.props.user && (!prev.user || prev.user.enableDarkMode !== this.props.user.enableDarkMode))
            this.setLoaderData(this.props.user);
    }

    setLoaderData = (user) => {
        this.loaderData = loaderData(useDarkMode(user) ? [0.04,0.04,0.04]:[1,1,1]);
        this.setState({ tmp: this.state.tmp + 1 });
    }

    animateLoaderOpacity = (t) => {
        if (t > 30)
            return {};

        return t%10 === 0 || t%10 === 9 ? { opacity: 0 } : {};
    }

    render = () => {
        // const dark = useDarkMode(this.props.user);
        return (<div
            className="loader"
            style={this.props.zIndex ? {
                zIndex: this.props.zIndex
            } : {}}
        >

            <Lottie
                options={{
                    loop: true,
                    autoplay: true,
                    animationData: this.loaderData,
                    rendererSettings: {
                        preserveAspectRatio: 'xMidYMid slice'
                    }
                }}
                height={200}
                width={200}
                isStopped={false}
                isPaused={false}
                style={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    marginTop: -110,
                    // marginLeft: -200
                    marginLeft: -100,
                    // boxShadow: '0 0 40px 40px ' + (dark ? 'rgb(10,10,10)' : 'white'),
                    // backgroundColor: dark ? 'rgb(10,10,10)' : 'white',
                    // borderRadius: '50%'
                }}
            />
        
            {
                typeof this.props.loading === "string" ? 
                    <div className="loader-text">{this.props.loading}</div> 
                : 
                    typeof this.props.loading === 'function'?
                    <div className="loader-text">{this.props.loading()}</div> 
                :
                    <div
                        className="loader-text"
                        style={this.animateLoaderOpacity(this.props.loading)}
                    >
                        {this.props.loading > 30 ? <>
                            Hmm, something's not right.<br />
                            Try refreshing...
                        </> :
                        this.props.loading > 20 ? "Almost there..." : 
                        this.props.loading > 10 ? "Just a minute..." :
                        "Loading..."}
                    </div>
            }

            {this.props.long ? <div className="loader-long">This may take a couple of minutes.<br />Hang tight!</div> : ""}
        
        </div>)
    }

};